import { createFileRoute, Link } from "@tanstack/react-router";
import { AuthCard } from "@/components/auth-card";
import { ForgotPasswordForm } from "@/features/auth/forgot-password/form";
import { m } from "@/lib/paraglide/messages.js";

export const Route = createFileRoute("/(public)/forgot-password")({
  component: () => (
    <AuthCard
      title={m.forgot_title()}
      description={m.forgot_description()}
      footer={
        <>
          {m.forgot_remembered()} <Link to="/login">{m.common_sign_in()}</Link>
        </>
      }
    >
      <ForgotPasswordForm />
    </AuthCard>
  ),
});
